<template>
  <div class="fixed top-0 left-0 w-[100vw] h-[100vh] bg-[rgba(0,0,0,0.4)] z-[999]" @click.self="closeModal">
    <div class="w-[90vw] max-w-[600px] h-[80vh] rounded-[10px] bg-white absolute top-1/2 left-1/2 -translate-y-[50%] -translate-x-[50%] p-[28px] overflow-hidden flex flex-col">
      <div class="flex justify-between items-center mb-6">
        <h3 class="text-[20px] font-bold">그룹 목록</h3>
        <button
          class="w-[32px] h-[32px] flex items-center justify-center rounded-[50%] hover:bg-gray-100"
          @click="closeModal"
        >
          <img src="@/assets/images/icon/ico_close_gray.svg" alt="닫기" />
        </button>
      </div>

      <!-- 검색 영역 -->
      <div class="mb-6">
        <div class="flex gap-3">
          <select
            v-model="searchType"
            class="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
          >
            <option value="title">그룹명</option>
            <option value="groupId">그룹 ID</option>
          </select>
          <input
            v-model="searchKeyword"
            type="text"
            placeholder="검색어를 입력하세요"
            class="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
            @keyup.enter="searchGroups"
          />
          <button
            @click="searchGroups"
            class="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            검색
          </button>
        </div>
      </div>

      <!-- 그룹 목록 -->
      <div class="flex-1 overflow-y-auto">
        <div v-if="loading" class="flex justify-center items-center h-32">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
        <div v-else-if="filteredGroups.length === 0" class="flex justify-center items-center h-32 text-gray-500">
          검색 결과가 없습니다.
        </div>
        <div v-else class="space-y-2">
          <div
            v-for="group in filteredGroups"
            :key="group.groupId"
            class="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
            @click="selectGroup(group)"
          >
            <div class="flex justify-between items-center">
              <div>
                <h4 class="font-semibold text-gray-900">{{ group.title }}</h4>
                <p class="text-sm text-gray-500">ID: {{ group.groupId }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 검색 결과 수 표시 -->
      <div v-if="filteredGroups.length > 0" class="mt-4 text-center text-sm text-gray-500">
        총 {{ filteredGroups.length }}개의 그룹이 검색되었습니다.
      </div>
    </div>
  </div>
</template>

<script>
import { useStudentStore } from '@/store';

export default {
  name: 'GroupSwitchModal',
  data() {
    return {
      studentStore: useStudentStore(),
      loading: false,
      searchType: 'title',
      searchKeyword: '',
      allGroups: [], // 전체 그룹 데이터
      filteredGroups: [], // 필터링된 그룹 데이터
      currentParams: {
        size: 300
      }
    };
  },
  mounted() {
    this.loadGroups();
  },
  watch: {
    searchKeyword() {
      this.filterGroups();
    },
    searchType() {
      this.filterGroups();
    }
  },
  methods: {
    async loadGroups() {
      this.loading = true;
      try {
        await this.studentStore.getGroupsAcademies(this.currentParams);
        this.allGroups = this.studentStore.groupSearch.content || [];
        this.filterGroups();
      } catch (error) {
        console.error('그룹 목록을 불러오는데 실패했습니다:', error);
      } finally {
        this.loading = false;
      }
    },
    filterGroups() {
      if (!this.searchKeyword.trim()) {
        this.filteredGroups = this.allGroups;
        return;
      }

      const keyword = this.searchKeyword.toLowerCase().trim();
      this.filteredGroups = this.allGroups.filter(group => {
        if (this.searchType === 'title') {
          return group.title && group.title.toLowerCase().includes(keyword);
        } else if (this.searchType === 'groupId') {
          return group.groupId && group.groupId.toLowerCase().includes(keyword);
        }
        return false;
      });
    },
    searchGroups() {
      this.filterGroups();
    },
    selectGroup(group) {
      this.$emit('select-group', group);
      this.closeModal();
    },
    closeModal() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
/* 스크롤바 스타일링 */
.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
